import { render, staticRenderFns } from "./saveRole.vue?vue&type=template&id=62a8c096&"
import script from "./saveRole.vue?vue&type=script&lang=js&"
export * from "./saveRole.vue?vue&type=script&lang=js&"
import style0 from "./saveRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports